import * as React from 'react';
import classNames from 'classnames';
import { assign as _assign, difference as _difference, includes as _includes } from 'lodash';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';
import { ConfigurationModel, BuiltInPartsModel, BuiltInPartsDefaultModel, transformStringToBoolean } from 'franke-trough-dependencies';
import { requestAPIActions } from 'loopback-react-request';
import { CheckboxPositions } from '../Utils';
import { ApronRequired } from '../ApronBacksplash';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './Recesses.messages';
import { isConfigurationEditable } from 'src/redux/utils.redux';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo } from '@fortawesome/free-solid-svg-icons';
import ConsolesOverlapChoice from '../Assemblies/ConsoleOverlapChoice';

export interface CosmeticTissueDispenserProps {
  configuration: GlobalPrivateState['configuration'];
  dispatch: any;
}

export interface CosmeticTissueDispenserState {
  tissueDispenser: boolean;
  tissueDispenserPosition: boolean[];
  paperTowelDispensersPosition: boolean[];
}

export class CosmeticTissueDispenserPartial extends React.Component<CosmeticTissueDispenserProps, CosmeticTissueDispenserState> {
  constructor(props: CosmeticTissueDispenserProps) {
    super(props);
    this.state = {
      tissueDispenser: false,
      tissueDispenserPosition: [],
      paperTowelDispensersPosition: [],
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleTissuePositionChange = this.handleTissuePositionChange.bind(this);
    this.handleTowelPositionChange = this.handleTowelPositionChange.bind(this);
  }

  componentDidMount() {
    this.setState({
      tissueDispenser: this.tissueDispenser,
      tissueDispenserPosition: (this.tissueDispenserPosition && transformStringToBoolean(this.tissueDispenserPosition)) || [],
      paperTowelDispensersPosition: (this.paperTowelDispensersPosition && transformStringToBoolean(this.paperTowelDispensersPosition)) || [],
    });
  }

  componentDidUpdate(prevProps: CosmeticTissueDispenserProps) {
    const configuration = this.configuration;
    const prevConfiguration = prevProps.configuration && prevProps.configuration.result;
    
    if ((configuration && configuration.updated_at) !== (prevConfiguration && prevConfiguration.updated_at)) {
      if (this.tissueDispenser !== this.state.tissueDispenser) {
        this.setState({
          tissueDispenser: this.tissueDispenser,
        });
      }
      if (this.tissueDispenserPosition && _difference(this.tissueDispenserPosition, this.state.tissueDispenserPosition)) {
        this.setState({
          tissueDispenserPosition: transformStringToBoolean(this.tissueDispenserPosition),
        });
      }
      if (this.paperTowelDispensersPosition && _difference(this.paperTowelDispensersPosition, this.state.paperTowelDispensersPosition)) {
        this.setState({
          paperTowelDispensersPosition: this.paperTowelDispensersPosition,
        });
      }
    }
  }

  public render() {
    const { tissueDispenser, tissueDispenserPosition, paperTowelDispensersPosition } = this.state;
    const tissueDispenserPositionDefaults = this.tissueDispenserPositionDefaults && this.tissueDispenserPositionDefaults.isEnabled;
    const paperTowelDispensersPositionDefaults = this.paperTowelDispensersPositionDefaults && this.paperTowelDispensersPositionDefaults.isEnabled;
    const configurationId = this.props.configuration.result && this.props.configuration.result.id;

    // TODO - Compare isEnabled with values, to check if the selection is for current or not

    return (
      <div className="partial-cosmetic-tissue-dispenser position-relative pb-4">
        <ConsolesOverlapChoice id="apronOverlap" />
        
        {this.tissueDispenserDefaults && this.tissueDispenserDefaults.allValues && this.tissueDispenserDefaults.allValues.map((value, index) => {
          const key = `has_tissue_dispenser_${index}`;
          const disabled = !isConfigurationEditable() || !(_includes(this.tissueDispenserDefaults && this.tissueDispenserDefaults.values, value));

          return (
            <React.Fragment key={key}>
              <div className="col-12">
                <label
                  className={classNames({
                    disabled: disabled, 
                  })}
                >
                  {!value ? (
                    <span>
                      <FormattedMessage {...MESSAGES.cosmeticTissueDispenserWithout} />
                    </span>
                  ) : (
                    <span>
                      <FormattedMessage {...MESSAGES.cosmeticTissueDispenserWith} />
                    </span>
                  )}
                  <input 
                    className={classNames({
                      disabled: disabled,
                    })}
                    checked={tissueDispenser === value}
                    disabled={disabled}
                    onChange={this.handleChange}
                    name="tissueDispenser"
                    type="radio"
                    value={value.toString()}
                  />
                  <span className="checkmark" />
                </label>
              </div>
              <>
                {tissueDispenser && value.toString() === 'true' 
                  && (
                  <>
                    <div className="form-group position-relative mt-4">
                      <span className="small mb-2">
                        <FormattedMessage {...MESSAGES.paperTowelDispenser} />
                        <Link className="info-icon-plain" to={`/configuration/${configurationId}/recesses/PROVIDER`}>
                          <FontAwesomeIcon icon={faInfo} />
                        </Link>
                      </span>
                      <CheckboxPositions
                        defaults={paperTowelDispensersPosition}
                        enabled={paperTowelDispensersPositionDefaults || []}
                        id={'paper_towel_dispenser_positions'}
                        positionChange={this.handleTowelPositionChange}
                        disabled={disabled}
                        division={'quarters'}
                        className={'rc-slider-troughed'}
                      />
                    </div>
                    <div className="form-group position-relative mt-4">
                      <span className="small mb-2">
                        <FormattedMessage {...MESSAGES.cosmeticTissueDispenser} />
                        <Link className="info-icon-plain" to={`/configuration/${configurationId}/recesses/COSMETIC`}>
                          <FontAwesomeIcon icon={faInfo} />
                        </Link>
                        <ApronRequired id={`tissue_dispenser`} />
                      </span>
                      <CheckboxPositions
                        defaults={tissueDispenserPosition}
                        enabled={tissueDispenserPositionDefaults || []}
                        id={'tissue_dispenser_positions'}
                        positionChange={this.handleTissuePositionChange}
                        disabled={disabled}
                        division={'quarters'}
                        className={'rc-slider-troughed'}
                        conflictingPositions={this.railCutoutPositions}
                      />
                    </div>
                  </>
                )}
              </>
            </React.Fragment>
          );
        })}
      </div>
    );
  }
  
  /*
  private get apron(): ApronBackSplashModel['apron'] | null | undefined {
    return this.configuration &&
      this.configuration.apronBackSplash &&
      this.configuration.apronBackSplash.apron;
  }

  private get apronHeight(): ApronBackSplashModel['apronHeight'] | null | undefined {
    return this.configuration &&
      this.configuration.apronBackSplash &&
      this.configuration.apronBackSplash.apronHeight;
  }

  private get apronRequired(): boolean {
    return this.apron === 'without' ||
      (this.apron === 'with' && !this.apronHeight) || 
      (this.apron === 'with' && (this.apronHeight && this.apronHeight < 150)) ? true : false;
  }
  */

  
  private get builtInPartsDefaults(): BuiltInPartsDefaultModel | undefined {
    return this.configuration &&
      this.configuration.defaults &&
      this.configuration.defaults.builtInParts;
  }

  private get configuration(): ConfigurationModel | undefined {
    return this.props.configuration && this.props.configuration.result;
  }

  private dispatchConfiguration(props: CosmeticTissueDispenserState) {
    if (!this.configuration || !this.configuration.builtInParts) {
      return;
    }
    
    const builtInParts: BuiltInPartsModel = this.configuration.builtInParts;

    const data: BuiltInPartsModel = _assign({}, builtInParts, {
      tissueDispenser: props.tissueDispenser,
      tissueDispenserPosition: props.tissueDispenserPosition && transformStringToBoolean(props.tissueDispenserPosition) || null,
      paperTowelDispensersPosition: props.paperTowelDispensersPosition || null,
    });

    this.props.dispatch(requestAPIActions.load(
      'configuration', {
        url: `/Configurations/${this.configuration && this.configuration.id}`,
        options: {
          method: 'PATCH',
          data: {builtInParts: data}
        },
      },
      true,
    ));
  }

  private handleChange(event: React.SyntheticEvent<HTMLInputElement>) {
    const { paperTowelDispensersPosition, tissueDispenserPosition } = this.state;
    const target = event.target as HTMLInputElement;
    const tissueDispenser = target.value === 'true' ? true : false;

    const state: CosmeticTissueDispenserState = {
      ...this.state,
      tissueDispenser: tissueDispenser,
      paperTowelDispensersPosition: tissueDispenser ? paperTowelDispensersPosition && transformStringToBoolean(paperTowelDispensersPosition) : [],
      tissueDispenserPosition: tissueDispenser ? tissueDispenserPosition && transformStringToBoolean(tissueDispenserPosition) : [],
    };
    
    this.setState(state);
    this.dispatchConfiguration(state);
  }

  private handleTissuePositionChange(positions: boolean[]) {
    const state: CosmeticTissueDispenserState = {
      ...this.state,
      tissueDispenserPosition: transformStringToBoolean(positions)
    };
    
    this.setState(state);
    this.dispatchConfiguration(state);
  }

  private handleTowelPositionChange(positions: boolean[]) {
    const state: CosmeticTissueDispenserState = {
      ...this.state,
      paperTowelDispensersPosition: transformStringToBoolean(positions)
    };
    
    this.setState(state);
    this.dispatchConfiguration(state);
  }

  private get tissueDispenser(): BuiltInPartsModel['tissueDispenser'] {
    return this.configuration &&
      this.configuration.builtInParts &&
      this.configuration.builtInParts.tissueDispenser ? this.configuration.builtInParts.tissueDispenser : false;
  }

  private get tissueDispenserPosition(): BuiltInPartsModel['tissueDispenserPosition'] | null | undefined {
    return this.configuration &&
      this.configuration.builtInParts &&
      this.configuration.builtInParts.tissueDispenserPosition &&
      transformStringToBoolean(this.configuration.builtInParts.tissueDispenserPosition);
  }

  private get paperTowelDispensersPosition(): BuiltInPartsModel['paperTowelDispensersPosition'] | null | undefined {
    return this.configuration &&
      this.configuration.builtInParts &&
      this.configuration.builtInParts.paperTowelDispensersPosition;
  }

  private get tissueDispenserPositionDefaults(): BuiltInPartsDefaultModel['tissueDispenserPosition'] | undefined {
    return this.builtInPartsDefaults &&
      this.builtInPartsDefaults.tissueDispenserPosition;
  }

  private get paperTowelDispensersPositionDefaults(): BuiltInPartsDefaultModel['tissueDispenserPosition'] | undefined {
    return this.builtInPartsDefaults &&
      this.builtInPartsDefaults.paperTowelDispensersPosition;
  }

  private get tissueDispenserDefaults(): BuiltInPartsDefaultModel['tissueDispenser'] | undefined {
    return this.builtInPartsDefaults &&
      this.builtInPartsDefaults.tissueDispenser;
  }

  private get railCutoutPositions(): BuiltInPartsModel['cutOutDisposalsPosition'] | null | undefined | false {
    const isRailCutout = this.configuration && this.configuration.builtInParts && this.configuration.builtInParts.cutOutDisposalsType && this.configuration.builtInParts.cutOutDisposalsType.includes('RAIL');
    const cutoutPositions = this.configuration && this.configuration.builtInParts && this.configuration.builtInParts.cutOutDisposalsType && this.configuration.builtInParts.cutOutDisposalsPosition;
    
    return isRailCutout && cutoutPositions;
  }
}

export const CosmeticTissueDispenser = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
}))(CosmeticTissueDispenserPartial);

export default CosmeticTissueDispenser;
